export enum Control {
    ZipCode = "ZipCode",
    Region = "Region",
    DistrictType = "DistrictType",
    DistrictName = "DistrictName",
    SettlementType = "SettlementType",
    SettlementName = "SettlementName",
    CityType = "CityType",
    CityName = "CityName",
    StructureType = "StructureType",
    StructureName = "StructureName",
    StreetType = "StreetType",
    StreetName = "StreetName",
    Stead = "Stead",
    HouseType = "HouseType",
    HouseNumber = "HouseNumber",
    HousingType = "HousingType",
    HousingNumber = "HousingNumber",
    BuildingType = "BuildingType",
    BuildingNumber = "BuildingNumber",
    ApartmentType = "ApartmentType",
    ApartmentNumber = "ApartmentNumber",
    RoomType = "RoomType",
    RoomNumber = "RoomNumber",
    Id = "Id",
}

export const defaultPaths = {
    ZipCode: "Индекс",
    Region: "Регион",
    DistrictType: "МуниципРайон/ВидКод",
    DistrictName: "МуниципРайон/Наим",
    SettlementType: "ГородСелПоселен/ВидКод",
    SettlementName: "ГородСелПоселен/Наим",
    CityType: "НаселенПункт/Вид",
    CityName: "НаселенПункт/Наим",
    StructureType: "ЭлПланСтруктур/Тип",
    StructureName: "ЭлПланСтруктур/Наим",
    StreetType: "ЭлУлДорСети/Тип",
    StreetName: "ЭлУлДорСети/Наим",
    Stead: "ЗемелУчасток",
    HouseType: "Здание/0/Тип",
    HouseNumber: "Здание/0/Номер",
    HousingType: "Здание/1/Тип",
    HousingNumber: "Здание/1/Номер",
    BuildingType: "Здание/2/Тип",
    BuildingNumber: "Здание/2/Номер",
    ApartmentType: "ПомещЗдания/Тип",
    ApartmentNumber: "ПомещЗдания/Номер",
    RoomType: "ПомещКвартиры/Тип",
    RoomNumber: "ПомещКвартиры/Номер",
    Id: "ИдНом",
};

export const controlsApiPaths = {
    "garhouse.postalCode": "ZipCode",
    "region.code": "Region",
    "municipaldistrict.abbreviation": "DistrictType",
    "municipaldistrict.name": "DistrictName",
    "urbansettlement.abbreviation": "SettlementType",
    "urbansettlement.name": "SettlementName",
    "district.abbreviation": "CityType",
    "district.name": "CityName",
    "planningstructure.abbreviation": "StructureType",
    "planningstructure.name": "StructureName",
    "street.abbreviation": "StreetType",
    "street.name": "StreetName",
    "stead.number": "Stead",
    "garhouse.houseType": "HouseType",
    "garhouse.houseNum": "HouseNumber",
    "garhouse.addType1": "HousingType",
    "garhouse.addNum1": "HousingNumber",
    "garhouse.addType2": "BuildingType",
    "garhouse.addNum2": "BuildingNumber",
    "room.flatType": "ApartmentType",
    "room.flatNumber": "ApartmentNumber",
    "room.roomType": "RoomType",
    "room.roomNumber": "RoomNumber",
} as const;

export type ControlApiPath = keyof typeof controlsApiPaths;
